module.exports = __webpack_public_path__ + "static/Roboto-Bold-b1c40adf08a6b491683514dfac3ab054.woff2";